import { Box, Tooltip, TooltipProps, styled, tooltipClasses } from "@mui/material"

export const UserGroupsDetailTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: "#001A50",
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: "#001A50",
        boxShadow: "0px 3px 6px #00000029",
        padding: 0
    },
}))